import { Exchange } from 'urql';
import { map, pipe } from 'wonka';

export interface PermissionlessFieldInfo {
  field: string;
  paths: Array<string>;
  owner?: string;
}

export type GqlPermissionWarningExchange = (
  addPermissionlessField: (fieldInfo: PermissionlessFieldInfo) => void
) => Exchange;

const gqlPermissionWarningExchange: GqlPermissionWarningExchange =
  (addPermissionlessField): Exchange =>
  ({ forward }) =>
  (ops$) => {
    return pipe(
      forward(ops$),
      map((res) => {
        const permissionlessFields =
          Object.values(
            res.extensions?.permissionlessCustomResolvedFields || {}
          ) || [];
        for (const fieldInfo of permissionlessFields) {
          addPermissionlessField(fieldInfo as PermissionlessFieldInfo);
        }
        return res;
      })
    );
  };

export default gqlPermissionWarningExchange;
